<template>
    <div class="d-inline-block">
        <b-btn :disabled="!$store.getters.getCanSign" variant="custom-danger" @click="showModal = true">Отказаться от подписания</b-btn>
        <b-modal v-model="showModal" centered no-close-on-backdrop no-close-on-esc scrollable size="md" title="Отказ от подписания дополнительного соглашения" @close="cancelSendModal" @hide="cancelSendModal">
            <template #modal-header-close>
                <button-close-modal />
            </template>
            <h6 class="text-danger fw-600">Дополнительное соглашение №{{ supplementaryAgreement.number }} будет удалено</h6>
            <h6 class="text-danger fw-600">Обращаем Ваше внимание, что данное действие необратимо.</h6>
            <div slot="modal-footer" class="w-100 px-3">
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button :disabled="isDataSending" variant="custom-outline-secondary" class="mr-2" @click="cancelSendModal">Отмена</b-button>
                </b-overlay>
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button variant="custom-danger" @click="sendDecline">Отказаться</b-button>
                </b-overlay>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { minLength, required } from 'vuelidate/lib/validators';

export default {
    name: 'fl44-customer-sign-decline-supplementary-agreement-button',
    props: {
        purchase: {
            type: Object,
            required: true
        },
        supplementaryAgreement: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showModal: false,
            isDataSending: false
        };
    },
    validations: {
        comment: {
            required,
            minLength: minLength(10)
        }
    },
    methods: {
        cancelSendModal() {
            this.showModal = false;
            this.comment = '';
        },
        async sendDecline() {
            this.isDataSending = true;
            await this.$api.personal.fl44
                .signDeclineCustomerSupplementaryAgreement(this.purchase.id, this.supplementaryAgreement.id)
                .then((response) => {
                    if (response) {
                        this.cancelSendModal();
                        this.$emit('refresh');
                    }
                })
                .finally(() => {
                    this.isDataSending = false;
                });
        }
    }
};
</script>
